//css
import styles from './navbar.module.scss';
import {
  Stack,
  Typography,
  Divider,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Badge,
  Button,
} from '@mui/material';
import Link from 'next/link';
import { useState } from 'react';
import { businessHourTiming } from '../../../commons/utils/utils';
import PHONE_ICON from '../../../src/assets/images/icons/phone-side-nav.svg';
import SUPPORT_ICON from '../../../src/assets/images/icons/support-side-nav.svg';
import ACCOUNT_ICON from '../../../src/assets/images/icons/account.svg';
import SHIPPING_ICON from '../../../src/assets/images/icons/shipping.svg';

import INSTA_ICON from '../../../src/assets/images/icons/insta.svg';
import TWITTER_ICON from '../../../src/assets/images/icons/twitter.svg';
import FACEBOOK_ICON from '../../../src/assets/images/icons/facebook.svg';
import YOUTUBE_ICON from '../../../src/assets/images/icons/youtube.svg';
import ARROW_RIGHT_HEAD from '../../../src/assets/images/icons/right-arrow-head.svg';
import { ContainedButton } from '../../../commons/hoc';
import {
  MENU_DARK,
  SUBTRACT,
  UNION,
  ENERGY,
  ANXIETY,
  BRAIN,
  GROUP_FOCUS,
  VECTOR_IMMUNE,
  CARDIAC,
} from '../../../src/assets/images/icons';
import Router from 'next/router';

const isOnline = businessHourTiming();
const CustomMenuList = ({
  item,
  color = 'primary.main',
  sx,
  showOnline = false,
}) => {
  return (
    <>
      <Link href={item.link} underline="none">
        <MenuItem sx={{ ...sx }} disableRipple>
          {item.icon && (
            <ListItemIcon sx={{ justifyContent: 'left' }}>
              {item.icon}
            </ListItemIcon>
          )}
          <ListItemText sx={{ justifyContent: 'left' }}>
            <Typography variant="h5" color={color}>
              <a style={{ display: 'flex', alignItems: 'center' }}>
                {' '}
                {item.title}
                {showOnline && (
                  <Badge
                    className={`${
                      isOnline ? styles.onlineStatus : styles.offlineStatus
                    }`}
                    sx={{
                      pl: 2,
                      pb: 0.5,
                      color: 'warning',
                    }}
                    variant="dot"
                  />
                )}
              </a>
            </Typography>
          </ListItemText>
        </MenuItem>
      </Link>
    </>
  );
};

const NavMobileList = ({ items, sx }) => {
  return (
    <div className={styles.navContainer} style={sx}>
      {items.map((item, index) => (
        <div key={index} className={styles.navItem}>
          <Link href={item.link} className={styles.link}>
            <div className={styles.linkContent}>
              <div className={styles.textWrapper}>
                <Typography variant="h5" className={styles.title}>
                  {item.title}
                </Typography>
              </div>
              {item.icon && (
                <div className={styles.iconWrapper}>
                  <span>{item.icon}</span>
                </div>
              )}
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};
export default function Navbar({ height, isDark, router }) {
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleDropdownClick = (index, hasItems, url) => {
    if (hasItems) {
      Router.push(url);
    } else {
      setOpenDropdown(openDropdown === index ? null : index);
    }
  };
  const color = '#004152';

  const navProductMenu = [
    {
      icon: <UNION />,
      title: 'Pain Relief',
      link: '/products/relief-factor',
    },
    {
      icon: <GROUP_FOCUS />,
      title: 'Brain Health',
      link: '/products/think-factor',
    },
    {
      icon: <ANXIETY />,
      title: 'Anxiety Relief',
      link: '/products/zen-factor',
    },

    {
      icon: <ENERGY />,
      title: 'Energy',
      link: '/products/go-factor',
    },

    {
      icon: <SUBTRACT />,
      title: 'Sleep',
      link: '/products/z-factor',
    },
  ];
  const bottomFooterMenu = [
    {
      title: 'Account',
      icon: <ACCOUNT_ICON />,
      link: '/login',
    },
    {
      title: 'Sales: 888-488-3112',
      icon: <PHONE_ICON />,
      link: 'tel:+1-888-488-3112',
      showOnline: true,
    },
    {
      title: 'Support',
      icon: <SUPPORT_ICON />,
      link: '/support',
    },
    {
      title: 'Shipping Policies',
      icon: <SHIPPING_ICON />,
      link: '/policies/shipping',
    },
    {
      title: 'Returns Policy',
      icon: <SHIPPING_ICON />,
      link: '/policies/returns',
    },
  ];

  const socialMenu = {
    items: [
      {
        icon: <INSTA_ICON color="#004152" />,
        link: 'https://www.instagram.com/relieffactor/',
      },
      {
        icon: <TWITTER_ICON color="#004152" />,
        link: 'https://twitter.com/relieffactor',
      },
      {
        icon: <FACEBOOK_ICON color="#004152" />,
        link: 'https://facebook.com/relieffactor',
      },
      {
        icon: <YOUTUBE_ICON color="#004152" />,
        link: 'https://www.youtube.com/@relieffactor/',
      },
    ],
  };
  const nestedDropDownData = [
    {
      heading: 'Health Support',
      items: [
        {
          title: 'Vitamin D3 with Essential Cofactor',
          icon: <VECTOR_IMMUNE />,
          icon1: <CARDIAC />,
          link: '/products/vitamin-d-k',
        },
        {
          title: 'Berberine for Blood Sugar Support',
          icon: <CARDIAC />,
          link: ' /products/berberine',
        },
        {
          title: 'Supercharged B Vitamins',
          icon: <ENERGY />,
          link: '/products/vitamin-b-complex',
        },
        {
          title: 'Vessel Protection Essentials',
          icon: <VECTOR_IMMUNE />,
          icon1: <CARDIAC />,
          link: '/products/vessel-protection',
        },
        {
          title: 'Red Yeast Rice with CoQ10 for Heart Health',
          icon: <CARDIAC />,
          link: '/products/red-yeast-rice',
        },
        {
          title: 'Full Spectrum E Vitamins',
          icon: <VECTOR_IMMUNE />,
          icon1: <CARDIAC />,
          icon2: <ENERGY />,
          link: '/products/full-spectrum-e',
        },
        {
          title: 'NAC for Liver Support',
          icon: <VECTOR_IMMUNE />,
          link: '/products/nac',
        },
        {
          title: ' Vital Immune Support',
          icon: <VECTOR_IMMUNE />,
          link: '/products/immune-factors',
        },
        {
          title: '  Vitamin C with Antioxidant Boosters',
          icon: <VECTOR_IMMUNE />,
          icon1: <CARDIAC />,
          link: '/products/antioxidants',
        },
      ],
    },
    // {
    //   heading: 'Shop by Bundle',
    //   items: [
    //     {
    //       title: 'Vitamin B',
    //       icon: <MENU_DARK />,
    //       link: '/#',
    //     },
    //     {
    //       title: 'Vitamin C',
    //       icon: <MENU_DARK />,
    //       link: '/#',
    //     },
    //   ],
    // },
    // {
    //   heading: 'Our Science',
    //   items: [],
    //   url: '/products',
    // },
    // {
    //   heading: 'Subscribe & Save',
    //   items: [],
    //   url: '/#',
    // },
    // {
    //   heading: 'About Us',
    //   items: [],
    //   url: '/#',
    // },
  ];

  return (
    <Stack
      display="flex"
      flexDirection="column"
      justifyContent="start"
      columnGap={2}
      maxWidth="md"
      sx={{ px: 5 }}
      className={styles['nav-bg']}
    >
      <div
        style={{
          height,
          width: '100%',
          transition: 'all .2s',
        }}
      />

      <div className={styles.container}>
        <div className={styles.header}>
          <Typography sx={{ fontWeight: 'bold' }}>Shop by Solution</Typography>
        </div>
        <div>
          <NavMobileList items={navProductMenu} />
        </div>
        <div className={styles.footer}>
          <ContainedButton
            className={styles.footerButton}
            onClick={() => Router.push('/products')}
            arrow={true}
          >
            <Typography variant="h5">Shop All Products</Typography>
          </ContainedButton>
        </div>
      </div>

      <Divider
        sx={{
          bgcolor: '#989898',
          width: '100%',
          opacity: 0.7,
          margin: 'auto',
        }}
      />

      {openDropdown !== null ? (
        <div
          className={styles.dropdownContainer}
          style={{ '--dropdown-bg-color': isDark ? '#333' : '#fff' }}
        >
          <Stack className={styles.submenuStack}>
            <Button
              className={styles.submenuHeader}
              onClick={() => setOpenDropdown(null)}
            >
              <span className={styles.backArrow}>
                {' '}
                <ARROW_RIGHT_HEAD />
              </span>
              <Typography variant="h3" className={styles.submenuHeading}>
                {nestedDropDownData[openDropdown].heading}
              </Typography>
            </Button>
            {nestedDropDownData[openDropdown].items.map((item, itemIndex) => (
              <div
                key={itemIndex}
                className={styles.item}
                onClick={() => router.push(item.link)}
              >
                <Typography variant="h4" className={styles.submenuItem}>
                  {item.title}
                </Typography>

                {item.icon && (
                  <span className={styles.itemIcon}>{item.icon}</span>
                )}
                {item.icon1 && (
                  <span className={styles.itemIcon}>{item.icon1}</span>
                )}
                {item.icon2 && (
                  <span className={styles.itemIcon}>{item.icon2}</span>
                )}
              </div>
            ))}
          </Stack>
        </div>
      ) : (
        <div>
          {nestedDropDownData.map((dropdown, index) => (
            <>
              <Button
                className={styles.mainDropdownContainer}
                onClick={() =>
                  handleDropdownClick(
                    index,
                    dropdown.items.length == 0,
                    dropdown.url
                  )
                }
                key={index}
              >
                <Typography className={styles.mainDropdownHeading} variant="h3">
                  {dropdown.heading}
                </Typography>
                {dropdown.items.length !== 0 && (
                  <span className={styles.openArrow}>
                    <ARROW_RIGHT_HEAD />
                  </span>
                )}
              </Button>
              <Divider className={styles.divider} />
            </>
          ))}
        </div>
      )}

      <Stack
        display="flex"
        flexDirection="column"
        sx={{ pt: 5 }}
        justifyContent="flex-start"
      >
        {bottomFooterMenu.map((item, i) => (
          <CustomMenuList
            key={i}
            item={item}
            index={i}
            color={color}
            sx={{ px: 0 }}
            showOnline={item.showOnline || false}
          />
        ))}
      </Stack>
      <Stack
        direction="row"
        alignItems="flex-start"
        sx={{ py: 2 }}
        columnGap={1}
      >
        {socialMenu.items.map((item, i) => (
          <Link href={item.link}>
            <MenuItem sx={{ p: 0 }} key={i}>
              <ListItemIcon sx={{ justifyContent: 'left' }}>
                {item.icon}
              </ListItemIcon>
            </MenuItem>
          </Link>
        ))}
      </Stack>
    </Stack>
  );
}
